/******************************************************************************
 * 
 * Strauss Motion
 * 
 * Copyright (c) 2022 Robimo GmbH
 *
 * Authors: Daniel Martinek
 *
 *****************************************************************************/

import { ContactState } from './interfaces';
import {
    CONTACT_SET_ORDERFOR,
    CONTACT_SET_CUSTOMERNUMBER,
    CONTACT_SET_FIRSTNAME,
    CONTACT_SET_LASTNAME,
    CONTACT_SET_COUNTRY,
    CONTACT_SET_ZIPCODE,
    CONTACT_SET_CITY,
    CONTACT_SET_ADDRESS,
    CONTACT_SET_TITLE,
    CONTACT_SET_OCCUPATION,
    CONTACT_SET_EMAIL,
    CONTACT_SET_PHONE,
    CONTACT_SET_COMMENT
} from './actions';


export const initialState :  ContactState = {
    orderFor: 'private',
    customerNumber: '',
    firstName: '',
    lastName: '',
    country: 'DE',
    zipCode: '',
    city: '',
    address: '',
    title: '',
    occupation: '',
    email: '',
    phone: '',
    comment: ''
};

export default function contact(state: ContactState = initialState, action : any) : ContactState {
    switch (action.type) {
        case CONTACT_SET_ORDERFOR:
            return Object.assign({}, state, {
                orderFor: action.orderFor
            });
        case CONTACT_SET_CUSTOMERNUMBER:
            return Object.assign({}, state, {
                customerNumber: action.customerNumber
            });
        case CONTACT_SET_FIRSTNAME:
            return Object.assign({}, state, {
                firstName: action.firstName
            });
        case CONTACT_SET_LASTNAME:
            return Object.assign({}, state, {
                lastName: action.lastName
            });
        case CONTACT_SET_COUNTRY:
            return Object.assign({}, state, {
                country: action.country
            });
        case CONTACT_SET_ZIPCODE:
            return Object.assign({}, state, {
                zipCode: action.zipCode
            });
        case CONTACT_SET_CITY:
            return Object.assign({}, state, {
                city: action.city
            });
        case CONTACT_SET_ADDRESS:
            return Object.assign({}, state, {
                address: action.address
            });
        case CONTACT_SET_TITLE:
            return Object.assign({}, state, {
                title: action.title
            });
        case CONTACT_SET_OCCUPATION:
            return Object.assign({}, state, {
                occupation: action.occupation
            });
        case CONTACT_SET_EMAIL:
            return Object.assign({}, state, {
                email: action.email
            });
        case CONTACT_SET_PHONE:
            return Object.assign({}, state, {
                phone: action.phone
            });
        case CONTACT_SET_COMMENT:
            return Object.assign({}, state, {
                comment: action.comment
            });
        default:
            return state;
    }
}
  